import { createFeatureSelector, createSelector, MemoizedSelector } from '@ngrx/store';
import { getById, textbausteinFeatureState, TextbausteinRootState } from './textbaustein.state';
import { TextbausteinId, TextbausteinResource } from './textbaustein.model';
import { StateResource } from '@schir-int-client/ngrx-helpers';

export const selectFeature = createFeatureSelector<TextbausteinRootState>(textbausteinFeatureState);

export function selectTextbausteinById(textbausteinId: TextbausteinId): MemoizedSelector<object, TextbausteinResource> {
	return createSelector(selectFeature, state => getById(state, textbausteinId));
}

export const selectTextbausteine: MemoizedSelector<
	object,
	StateResource<{
		[targetColumn: string]: TextbausteinResource[];
	}>
> = createSelector(selectFeature, (state: TextbausteinRootState) => {
	return state?.textbausteinRoot?.textbausteine;
});
